var _circle, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 92,
    viewBox: "0 0 108 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_204_2424)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_204_2424)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 19.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_204_2424)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1064 59.5156C71.0127 58.2412 71.5 56.7129 71.5 55.1452C71.5 53.5776 71.0127 52.0493 70.1064 50.7749L72.75 48.1122L74.3663 49.74C74.4823 49.857 74.6201 49.9498 74.7717 50.013C74.9234 50.0763 75.0859 50.1089 75.25 50.1089C75.4142 50.1089 75.5767 50.0763 75.7284 50.013C75.88 49.9498 76.0178 49.857 76.1338 49.74L81.1338 44.7037C81.2499 44.5869 81.342 44.4481 81.4049 44.2954C81.4677 44.1426 81.5001 43.9789 81.5001 43.8136C81.5001 43.6482 81.4677 43.4845 81.4049 43.3318C81.342 43.179 81.2499 43.0402 81.1338 42.9234L76.1338 37.8871C76.0178 37.7701 75.88 37.6773 75.7284 37.614C75.5767 37.5507 75.4142 37.5181 75.25 37.5181C75.0859 37.5181 74.9234 37.5507 74.7717 37.614C74.6201 37.6773 74.4823 37.7701 74.3663 37.8871L69.3663 42.9234C69.2502 43.0402 69.1581 43.179 69.0952 43.3318C69.0324 43.4845 69 43.6482 69 43.8136C69 43.9789 69.0324 44.1426 69.0952 44.2954C69.1581 44.4481 69.2502 44.5869 69.3663 44.7037L70.9824 46.3317L68.3389 48.9945C67.0737 48.0817 65.5564 47.5908 64 47.5908C62.4437 47.5908 60.9264 48.0817 59.6612 48.9945L56.5 45.8103V37.5182H46.5V47.5908H54.7324L57.8937 50.7749C56.9874 52.0493 56.5001 53.5776 56.5001 55.1452C56.5001 56.7129 56.9874 58.2412 57.8937 59.5156L55.25 62.1783L53.6338 60.5505C53.5178 60.4335 53.38 60.3407 53.2284 60.2774C53.0767 60.2141 52.9142 60.1815 52.75 60.1815C52.5859 60.1815 52.4234 60.2141 52.2717 60.2774C52.1201 60.3407 51.9823 60.4335 51.8663 60.5505L46.8663 65.5868C46.7502 65.7036 46.6581 65.8424 46.5952 65.9951C46.5324 66.1479 46.5 66.3116 46.5 66.4769C46.5 66.6423 46.5324 66.806 46.5952 66.9587C46.6581 67.1115 46.7502 67.2502 46.8663 67.3671L51.8663 72.4034C51.9823 72.5203 52.1201 72.6131 52.2717 72.6764C52.4234 72.7397 52.5859 72.7723 52.75 72.7723C52.9142 72.7723 53.0767 72.7397 53.2284 72.6764C53.38 72.6131 53.5178 72.5203 53.6338 72.4034L58.6338 67.3671C58.7499 67.2502 58.842 67.1115 58.9049 66.9587C58.9677 66.806 59.0001 66.6423 59.0001 66.4769C59.0001 66.3116 58.9677 66.1479 58.9049 65.9951C58.842 65.8424 58.7499 65.7036 58.6338 65.5868L57.0177 63.9588L59.6612 61.296C60.9264 62.2088 62.4437 62.6997 64 62.6997C65.5564 62.6997 67.0737 62.2088 68.3389 61.296L71.5 64.4802V72.7723H81.5V62.6997H73.2677L70.1064 59.5156ZM75.25 40.5577L78.4824 43.8136L75.25 47.0694L72.0177 43.8136L75.25 40.5577ZM52.75 69.7328L49.5177 66.4769L52.75 63.2211L55.9824 66.4769L52.75 69.7328ZM54 45.0726H49V40.0363H54V45.0726ZM59 55.1452C59 54.1492 59.2933 53.1754 59.8427 52.3472C60.3921 51.519 61.173 50.8735 62.0866 50.4923C63.0003 50.1111 64.0056 50.0114 64.9755 50.2057C65.9454 50.4 66.8363 50.8797 67.5356 51.584C68.2348 52.2884 68.711 53.1858 68.904 54.1627C69.0969 55.1397 68.9979 56.1523 68.6194 57.0725C68.241 57.9928 67.6001 58.7794 66.7779 59.3328C65.9556 59.8862 64.989 60.1815 64 60.1815C62.6744 60.18 61.4035 59.649 60.4662 58.7048C59.5288 57.7606 59.0015 56.4805 59 55.1452ZM74 65.2178H79V70.2542H74V65.2178Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_204_2424",
    x: -5,
    y: -6,
    width: 138,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_204_2424"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_204_2424",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_2424",
    x1: -9.17563,
    y1: -50.6818,
    x2: 61.8865,
    y2: -37.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_2424",
    x1: 106.029,
    y1: 68.5515,
    x2: 40.0421,
    y2: 63.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase2);
export default __webpack_public_path__ + "static/media/Phase 2.09994857f371e0a28475d87a138844e5.svg";
export { ForwardRef as ReactComponent };